import iconComment from '../../../assets/images/StockAnalysis/icon-comment.svg'
import iconPlus from '../../../assets/images/StockAnalysis/icon-plus.svg'
import iconSearch from '../../../assets/images/StockAnalysis/icon-search.svg'

import { AutoComplete, Popover } from 'antd'
import { compareValue, formatMoney, slugify } from 'Helpers/helpFunction'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeInputSearchStock, changeTabActive, changeTabActiveMobile } from 'store/actionReducers/StocksAnalysisStore'
import './SelectStocks.scss'
import useChart from 'hook/useChart'
import { constUrlBase } from 'constants/api'
import { useHistory } from 'react-router-dom'

export default function SelectStocks() {
  const dispatch = useDispatch();
  const history = useHistory();
  const CompanyStore = useSelector((state: any) => state?.CompanyStore)
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const ChartStore = useSelector((state: any) => state?.ChartStore)
  const AStore = useSelector((state: any) => state?.AStore);
  const [ValueSearchAutoComplete, setValueSearchAutoComplete] = useState(StocksAnalysisStore?.inputSearch)
  const { makePrice } = useChart();
  const [FirstTextWrite, setFirstTextWrite] = useState(true)
  const [openAutocomplete, setOpenAutocomplete] = useState(false)
  const itemAuto = useRef<any>();

  const tabActive = StocksAnalysisStore?.tabActive
  const tabActiveMobile = StocksAnalysisStore?.tabActiveMobile
  const [options, setOptions] = useState<any>([]);
  let volumn = 0
  let priceOpen = 0
  let priceClose = 0
  let PriceVolatility = 0 // gia chenh lech
  let PercentPriceVolatility = 0 // phan tram chenh lech

  const ceiling = ChartStore?.stockInformation?.ceiling ? ChartStore?.stockInformation?.ceiling / 1000 : 0 //gia tran
  const floor = ChartStore?.stockInformation?.floor ? ChartStore?.stockInformation?.floor / 1000 : 0 // gia san
  const reference = ChartStore?.stockInformation?.reference ? ChartStore?.stockInformation?.reference / 1000 : 0 // gia san
  const high = ChartStore?.stockInformation?.high ? ChartStore?.stockInformation?.high / 1000 : 0 // gia san
  const low = ChartStore?.stockInformation?.low ? ChartStore?.stockInformation?.low / 1000 : 0 // gia san
  const open = ChartStore?.stockInformation?.open ? ChartStore?.stockInformation?.open / 1000 : 0 // gia san

  if (StocksAnalysisStore?.inputSearch) {
    volumn = StocksAnalysisStore?.priceStockAnalysis[StocksAnalysisStore?.inputSearch]?.volumn
    priceOpen = StocksAnalysisStore?.priceStockAnalysis[StocksAnalysisStore?.inputSearch]?.priceOpen
    priceClose = StocksAnalysisStore?.priceStockAnalysis[StocksAnalysisStore?.inputSearch]?.priceClose
    PriceVolatility = makePrice(reference, priceClose).PriceVolatility
    PercentPriceVolatility = makePrice(reference, priceClose).PercentPriceVolatility
  }

  const handleChangeTabMobile = (tab: string) => {
    dispatch(changeTabActiveMobile({ tabActiveMobile: tab }))
  }

  const handleChangePageActive = (tab: string) => {
    dispatch(changeTabActive({ tabActive: tab }))
  }

  const onSelect = (data: string) => {
    // console.log('onSelect', data);
    setOpenAutocomplete(false)
    if (itemAuto?.current) {
      itemAuto.current.blur()
    }
    setValueSearchAutoComplete(data)
    dispatch(changeInputSearchStock({ value: data, loading: true }))
    const companyNameFilter = CompanyStore?.allCompany.filter((item: any) => {
      return item?.code === data ? item?.organname : ''
    })
    const companyNameSearch = companyNameFilter?.[0]?.organname || ''
    history.push(`${constUrlBase.phan_tich_co_phieu.url}/${data}-${slugify(companyNameSearch)}?stock=${data}`)
    dispatch(changeInputSearchStock({ value: data, loading: true }))
  };

  const onSearch = (searchText: string) => {
    let obj: any = [];
    if (CompanyStore?.allCompany) {
      CompanyStore?.allCompany.filter((item: any) => {
        const code = item.code;
        const organname = item.organname;
        const exchange = item.exchange;
        const textSearch = searchText ? searchText : ''

        if (code && searchText &&
          ((code.toLowerCase()).indexOf(textSearch.toLowerCase()) > -1
            // ||
            // (organname.toLowerCase()).indexOf(textSearch.toLowerCase()) > -1 ||
            // (exchange.toLowerCase()).indexOf(textSearch.toLowerCase()) > -1
          )) {
          obj.push({ value: code, label: `${code} - ${organname} - ${exchange}` })
        }
      });
    }
    setOptions([...obj])
  };

  const objectCompany = CompanyStore?.allCompany.filter((item: any) => {
    return item?.code === StocksAnalysisStore?.inputSearch ? item?.organname : ''
  })
  const companyName = objectCompany?.[0]?.organname || ''
  const exchange = objectCompany?.[0]?.exchange || ''
  

  const valueGrowthRanking = AStore?.Overview?.growthRanking ? Object.keys(AStore?.Overview?.growthRanking)?.[0] : ''
  const colorGrowthRanking = AStore?.Overview?.growthRanking ? compareValue(Object.keys(AStore?.Overview?.growthRanking)?.[0]) : '#ffffff'
  const valueRanking = AStore?.Overview?.valueRanking ? Object.keys(AStore?.Overview?.valueRanking)?.[0] : ''
  const colorRanking = AStore?.Overview?.valueRanking ? compareValue(Object.keys(AStore?.Overview?.valueRanking)?.[0]) : '#ffffff'
  const valueMomentum = AStore?.Overview?.momentum ? Object.keys(AStore?.Overview?.momentum)?.[0] : ''
  const colorMomentum = AStore?.Overview?.momentum ? compareValue(Object.keys(AStore?.Overview?.momentum)?.[0]) : '#ffffff'
  const valueDscRanking = AStore?.Overview?.dscRanking ? Object.keys(AStore?.Overview?.dscRanking)?.[0] : ''
  const colorDscRanking = AStore?.Overview?.dscRanking ? compareValue(Object.keys(AStore?.Overview?.dscRanking)?.[0]) : '#ffffff'
  const textGrowthRanking = AStore?.Overview?.growthRanking ? Object.values(AStore?.Overview?.growthRanking) : null
  const textValueRanking = AStore?.Overview?.valueRanking ? Object.values(AStore?.Overview?.valueRanking) : null
  const textMomentum = AStore?.Overview?.momentum ? Object.values(AStore?.Overview?.momentum) : null

  // ceiling
  let colorPrice = '#ffd900'
  if (PriceVolatility && PriceVolatility < 0) {
    colorPrice = '#e31e4d'
  } else if (PriceVolatility && PriceVolatility > 0) {
    colorPrice = '#2ad03d'
  }

  if (priceClose === ceiling) {
    colorPrice = '#f0f'
  } else if (priceClose === floor) {
    colorPrice = '#1eeeee'
  } else if (priceClose === reference) {
    colorPrice = '#ffd900'
  }

  const handleChangeAutoComplete = (value: any) => {
    setValueSearchAutoComplete(value)
    setOpenAutocomplete(true)
  }

  useEffect(() => {
    if (StocksAnalysisStore?.inputSearch !== ValueSearchAutoComplete) {
      setValueSearchAutoComplete(StocksAnalysisStore?.inputSearch)
    }
  }, [StocksAnalysisStore?.inputSearch])

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (itemAuto?.current) {
        if (event.keyCode === 13) {
          itemAuto?.current.blur();
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
          if (FirstTextWrite) {
            itemAuto?.current.focus();
          }
        }
      }
    }

    document.addEventListener("keydown", handleClickOutside);
    return () => {
      document.removeEventListener("keydown", handleClickOutside);
    };
  }, [itemAuto]);

  useEffect(() => {
    setFirstTextWrite(false)
  }, [])

  const hadleFocus = () => {
    if (!FirstTextWrite) {
      setValueSearchAutoComplete('')
    }
    setOpenAutocomplete(true)
  }

  const handleBlur = () => {
    setOpenAutocomplete(false)
  }

  return (
    <>
      <div className="ltyRqTpEpW">
        <div className="hNHivQHCCP">
          <div className="RxZWWnkQes">Chọn cổ phiếu </div>
          <div className="fOiDwZOPtB">
            <AutoComplete
              ref={itemAuto}
              open={openAutocomplete}
              options={options}
              onChange={(value) => handleChangeAutoComplete(value)}
              defaultActiveFirstOption={true}
              onFocus={() => hadleFocus()}
              onBlur={() => handleBlur()}
              onSelect={onSelect}
              onSearch={onSearch}
              value={ValueSearchAutoComplete}
              defaultValue={ValueSearchAutoComplete}
              className='fvNbzwjeLY'
            />
            <img src={iconSearch} alt="" className='YotiEOJAqR' />
          </div>
          {/* <div className="qmDkxpCdjK" onClick={() => handleClickAnalysis()}>Phân tích</div> */}
        </div>
        <div className="fPsTAkboUD">
          <div className="ZArDkNmAlw">
            <div className="xEraLXufxb">
              <div className='jnrmuhuksf'>
                <div className="sDszzXZQEo">{StocksAnalysisStore?.inputSearch}</div>
                <div className="oXMayRZqVV">{companyName} - {exchange}</div>
              </div>
              <div className='zhjrusnloz'>
                <div className="rwofvpbpnj"><img src={iconPlus} alt="" className='sxktjmqotl' /></div>
                <div className="rwofvpbpnj"><img src={iconComment} alt="" className='sxktjmqotl' /></div>
              </div>
            </div>
            <div className="tDEwhshWtV">
              <div className="XUGRzhnVuS" style={{ color: colorPrice }}>
                {priceClose ? formatMoney(priceClose.toString(), 2) : '--'}
              </div>
              <div className="GBxTDoaULq">
                <div className="SFMwzAOTVX">Biến động giá</div>
                <div className="BOcKDTGphc" style={{
                  color: PriceVolatility ? (PriceVolatility < 0 ? '#e31e4d' : '#2ad03d') : '#ffffff'
                }}>
                  {PriceVolatility ? PriceVolatility.toFixed(2) : '0'}({(PercentPriceVolatility > 0) ? `+${PercentPriceVolatility ? PercentPriceVolatility.toFixed(2) : ''}` :
                    `${PercentPriceVolatility ? PercentPriceVolatility.toFixed(2) : '0'}`}%)
                </div>
              </div>
              <div className="ADRsaqtFtO">
                <div className="mbiGnIfdid">Khối lượng giao dịch</div>
                <div className="JKUKSAMUBC">{volumn ? formatMoney(volumn.toString()) : '--'}</div>
              </div>
            </div>
            <div className="qbximfsmjt">
              <div className="ylthzrsvwl">
                <div className="vfuhubfpty">Trần</div>
                <div className="omxrlfbjvc ckajmloakg">{ceiling ? formatMoney(ceiling.toString(), 2) : '--'}</div>
              </div>
              <div className="ylthzrsvwl">
                <div className="vfuhubfpty">Sàn</div>
                <div className="omxrlfbjvc jtldyojagt">{floor ? formatMoney(floor.toString(), 2) : '--'}</div>
              </div>
              <div className="ylthzrsvwl">
                <div className="vfuhubfpty">Tham chiếu</div>
                <div className="omxrlfbjvc xnrjhwjzrw">{reference ? formatMoney(reference.toString(), 2) : '--'}</div>
              </div>
              <div className="ylthzrsvwl">
                <div className="vfuhubfpty">Mở cửa </div>
                <div className="omxrlfbjvc">{open ? formatMoney(open.toString(), 2) : '--'}</div>
              </div>
              <div className="ylthzrsvwl">
                <div className="vfuhubfpty">Thấp/Cao</div>
                <div className="omxrlfbjvc">{low ? formatMoney(low.toString(), 2) : '--'}/{high ? formatMoney(high.toString(), 2) : '--'}</div>
              </div>
            </div>
          </div>

          <div className='ntxneqsywa'>
            <div onClick={() => handleChangeTabMobile('tang-truong')} className={`cvraltibny ${tabActiveMobile === 'tang-truong' ? 'fkclodjtvz' : ''}`}>
              <div className='jilnbnsfka'>
                <div className='wlupufiyzs'>Tăng trưởng:</div>
                <div className='depilazciz' style={{ backgroundColor: colorGrowthRanking }}>{valueGrowthRanking}</div>
              </div>
            </div>
            <div onClick={() => handleChangeTabMobile('gia-tri')} className={`cvraltibny ${tabActiveMobile === 'gia-tri' ? 'fkclodjtvz' : ''}`}>
              <div className='jilnbnsfka'>
                <div className='wlupufiyzs'>Giá trị:</div>
                <div className='depilazciz' style={{ backgroundColor: colorRanking }}>{valueRanking}</div>
              </div>
            </div>
            <div onClick={() => handleChangeTabMobile('dong-luong')} className={`cvraltibny ${tabActiveMobile === 'dong-luong' ? 'fkclodjtvz' : ''}`}>
              <div className='jilnbnsfka'>
                <div className='wlupufiyzs'>Động lượng:</div>
                <div className='depilazciz' style={{ backgroundColor: colorMomentum }}>{valueMomentum}</div>
              </div>
            </div>
            <div onClick={() => handleChangeTabMobile('dsc')} className={`cvraltibny ${tabActiveMobile === 'dsc' ? 'fkclodjtvz' : ''}`}>
              <div className='jilnbnsfka'>
                <div className='wlupufiyzs'>DSC:</div>
                <div className='depilazciz' style={{ backgroundColor: colorDscRanking }}>{valueDscRanking}</div>
              </div>
            </div>
          </div>
          <Popover placement="bottom" title={''} content={'Tính năng sắp ra mắt'} trigger="hover">
            <div className="NOsLfIUoUx">
              <div className="SfHpxifrwt"><img src={iconComment} alt="" className='nOFwOEcSNZ' />Thêm vào danh mục</div>
              <div className="nqJrKMkWvG"><img src={iconPlus} alt="" className='nOFwOEcSNZ' />Tư vấn theo yêu cầu</div>
              <div className="KWvGmuZxFf">Đặt lệnh</div>
            </div>
          </Popover>
        </div>
        <div className="vZbjAZRDRG">
          <div className={`GewuKZUSjt ${tabActive === 'tang-truong' ? 'jkkwwilowh' : ''}`} onClick={() => handleChangePageActive('tang-truong')}>
            <Popover placement="bottom" title={''} content={'Đang cập nhật'} trigger="hover">
              <div className="FLeMynzKKk">
                Tăng trưởng:
                <div className="CZHQdKuzsZ" style={{ backgroundColor: colorGrowthRanking }}>
                  {valueGrowthRanking}
                </div>
              </div>
              <div className="MYfYKsHYdB">{textGrowthRanking}</div>
            </Popover>

          </div>
          <div className={`GewuKZUSjt ${tabActive === 'gia-tri' ? 'jkkwwilowh' : ''}`} onClick={() => handleChangePageActive('gia-tri')}>
            <Popover placement="bottom" title={''} content={'Đang cập nhật'} trigger="hover">
              <div className="FLeMynzKKk">
                Giá trị:
                <div className="CZHQdKuzsZ" style={{ backgroundColor: colorRanking }}>
                  {valueRanking}
                </div>
              </div>
              <div className="MYfYKsHYdB">{textValueRanking}</div>
            </Popover>
          </div>
          <div className={`GewuKZUSjt ${tabActive === 'dong-luong' ? 'jkkwwilowh' : ''}`} onClick={() => handleChangePageActive('dong-luong')}>
            <Popover placement="bottom" title={''} content={'Đang cập nhật'} trigger="hover">
              <div className="FLeMynzKKk">
                Động lượng:
                <div className="CZHQdKuzsZ" style={{ backgroundColor: colorMomentum }}>
                  {valueMomentum}
                </div>
              </div>
              <div className="MYfYKsHYdB">{textMomentum}</div>
            </Popover>
          </div>
        </div>
      </div>
    </>
  )
}